export default __webpack_public_path__ + "static/media/login-v2-dark.5b83e8c4.svg";